import { FormattedMessage } from 'react-intl';
import { Box, Card, CardContent, Collapse, Typography } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { getSessionVersionToken, useLocalization } from '@ui-framework/index';
import { useState } from 'react';
import SVGError from './error.svg';

function ErrorDisplay({
  text = null,
  subText = null,
  buttonComponent = null,
  errorMessage = null,
}) {
  const [open, setOpen] = useState(false);
  const { formatMessage } = useLocalization();
  const sessionVersion = getSessionVersionToken();

  return (
    <Grid2 container>
      <Grid2 xs={12} md={6} alignSelf="center">
        {text && <Typography variant="h5">{text}</Typography>}
        {subText && <Typography>{subText}</Typography>}
        {errorMessage && (
          <Box sx={{ mt: 2, mb: 2 }}>
            <Typography
              onClick={() => setOpen(prev => !prev)}
              sx={{
                cursor: 'pointer',
                textDecoration: 'underline',
                color: 'primary.main',
              }}>
              {open
                ? formatMessage({
                    id: 'HIDE_TECHNICAL_DETAILS',
                    defaultMessage: 'Hide Technical Details',
                  })
                : formatMessage({
                    id: 'SHOW_TECHNICAL_DETAILS',
                    defaultMessage: 'Show Technical Details',
                  })}
            </Typography>
            <Collapse sx={{ m: 0, p: 0 }} in={open}>
              <Card variant="outlined" sx={{ mt: 1, mb: 1 }}>
                <CardContent sx={{ p: 1, m: 0, pb: '10px !important' }}>
                  <Typography color="error">{errorMessage}</Typography>
                </CardContent>
              </Card>
            </Collapse>
          </Box>
        )}
        {buttonComponent}
      </Grid2>
      <Grid2 xs={12} md={6}>
        <Grid2>
          <img src={`${SVGError}?v=s${sessionVersion}`} alt="error" />
        </Grid2>
        <Grid2 textAlign="center">
          <Typography>
            <a href="https://storyset.com/people">
              <FormattedMessage
                id="PEOPLE_ILLUSTRATIONS_BY_STORYSET"
                defaultMessage="People illustrations by Storyset"
              />
            </a>
          </Typography>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}

export default ErrorDisplay;
